import React, { useState } from 'react';
import styles from "./Signup.module.css";
import { Col, Form, Row } from 'antd';
import { AntdDropdown, AntdInput, AntdPassInput, AntdSubmit } from '../../components';
import { useNavigate } from 'react-router-dom';
import AuthMiddleware from '../../store/Middlewares/AuthMiddleware';
import AlertAction from '../../store/Actions/AlertActions';
import { useDispatch } from 'react-redux';
import AutoCompleteAddress from '../../components/AutoCompleteAddress/AutoCompleteAddress';
import InputField from '../../components/input/InputField';

const Signup = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [address, setAddress] = useState([])

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log('Success values:', values);
    if (!values?.First_Name || !values?.Last_Name || !values?.email || !values?.password || !values?.Confirm_Password || address.length <= 0) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All fields required' }))
    }
    else if (values?.password !== values?.Confirm_Password) {
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Confirm password does not match!' }))
    }
    else {
      const data = { ...values, MultipleAddress: address }
      dispatch(AuthMiddleware.SignUp(data))
        .then((data) => {
          if (data?.success) {
            navigate('/')
          }
        })
        .catch((err) => console.log(err))
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onSelectLocation = (place) => {
    console.log('place', place);
    let currentLocation = {
      lat: place?.geometry?.location?.lat(),
      lng: place?.geometry?.location?.lng(),
      address: place?.formatted_address
    }
    setAddress(prevState => [...prevState, currentLocation])
  }

  const removeAddress = (index) => {
    const cpyAddress = [...address]
    cpyAddress.splice(index, 1)
    setAddress(cpyAddress)
  }
  console.log('address', address);
  return (
    <div className={styles.signUp_mainCon}>
      <Row className={styles.signUp_subMain}>
        <Col className={styles.signUp_leftCon}></Col>
        <Col className={styles.signUp_rightCon}>
          <h1>Sign Up As Contractor</h1>
          <Form
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className={styles.signUp_inputName}>
              <div className={styles.signUp_inputNameLeft}>
                <AntdInput placeholder={'John'} name={'First_Name'} label='First name' rules={[{ require: true, type: 'text', message: 'Please enter your first name' }]} />
              </div>
              <div className={styles.signUp_inputNameRight}>
                <AntdInput placeholder={'Depp'} name={'Last_Name'} label='Last name' rules={[{ require: true, type: 'text', message: 'Please enter your last name' }]} />
              </div>
            </div>
            <AntdInput placeholder={'JohnDepp@gmail.com'} name={'email'} label='Email' rules={[{ require: true, type: 'email', message: 'Please enter a valid email' }]} />
            <AntdPassInput placeholder={'********'} name={'password'} label='Password' rules={[{ require: true, type: 'text', message: 'Please enter your password' }, {
              pattern: /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
              message: `Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!`
            }]} />
            <AntdPassInput placeholder={'********'} name={'Confirm_Password'} label='Confirm Password' rules={[{ require: true, type: 'text', message: 'Please enter your password' }, {
              pattern: /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/,
              message: `Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!`
            }]} />
            <AutoCompleteAddress label={'Address'} onSelectLocation={onSelectLocation} clearFieldOnSelect={true} />
            {address.map((data, i) => (
              <InputField
                label={`Address ${i + 1}`}
                value={data.address}
                disabled
                crossIcon
                onIconClick={() => removeAddress(i)}
                // onChange={(e) => setFullName(e.target.value)}
                width='100%'
              />
            ))}
            <AntdSubmit text={'Create Account'} buttonStyle={{ margin: '15px 0px', height: '60px' }} />
            <div className={styles.signUp_text} >
              <p>If You Already Have An Account? Please</p>
              <span onClick={() => navigate('/')}>Log in</span>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default Signup;